import React from 'react';

// eslint-disable-next-line import/prefer-default-export,no-unused-vars
export function template(templateString, data) {
  // const pattern = /{\s*(\w+?)\s*}/gi; // {property}
  const reg = new RegExp(/{\s*(\w+?)\s*}/, 'g');
  const parts = templateString.split(reg);
  return (
    <div>
      {parts.map(part => {
        if (data[part]) {
          return data[part];
        }
        return part;
      })}
    </div>
  );
  // return templateString.replace(pattern, (_, token) => data[token] || '');
}



// WEBPACK FOOTER //
// ./src/utils/TemplateReplacement.js